import { Grid, Card, CardContent, Skeleton, Avatar, Box } from "@mui/material";

export const FileCardSkeleton = () => {
    return (
        <Grid item xs={12} sm={4} md={4}>
            <Card
                sx={{
                    position: "relative",
                    border: "1px solid #ddd",
                    borderRadius: "12px",
                    padding: "12px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    borderLeft: "4px solid #ddd",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 6,
                        right: 6,
                    }}
                >
                    <Skeleton variant="circular" width={32} height={32} />
                </Box>

                <Skeleton
                    variant="circular"
                    width={56}
                    height={56}
                    sx={{ mb: 1 }}
                />

                <CardContent
                    sx={{
                        p: 0,
                        pb: "0 !important",
                        width: "100%",
                    }}
                >
                    <Skeleton variant="text" width="70%" sx={{ mx: "auto" }} />
                    <Skeleton variant="text" width="35%" sx={{ mx: "auto" }} />
                    <Skeleton
                        variant="rounded"
                        width={80}
                        height={24}
                        sx={{ mt: 1, mx: "auto" }}
                    />
                </CardContent>
            </Card>
        </Grid>
    );
};

export default FileCardSkeleton;